<template>
  <div class="bbslist">
    <div class="pageTitle">论坛帖子审核</div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      >
      <div class="bbsbox" v-for="item in list" :key="'list_' + item.id" @click="bbsinfo(item.id)">
        <div class="bbstitle">新帖子</div>
        <div class="bbscontent">{{item.title?item.title:'查看详情'}}</div>
        <div class="bbscontent" v-for="itemt in item.topics" :key="'lists_' + itemt.id">#{{itemt.name}}#</div>
        <div class="bbsbind" v-if="item.is_audit==0">未审核</div>
        <div class="bbsbind" v-if="item.is_audit==1">审核通过</div>
        <div class="bbsbind" v-if="item.is_audit==2">审核未通过</div>
      </div>
    </van-list>
  </van-pull-refresh>
</div>
</template>
<script>
  import admin from '../../api/admin';
  import { mapState } from 'vuex';
  import { List,Icon,PullRefresh,NavBar } from 'vant';
  export default {
    data () {
      return {
        finished:false,
        loading:false,
        params:{
          page:1,
          size:6
        },
        newtime:'',
        list:[],
        refreshing:false,
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user
      })
    },
    created () {
      if(localStorage.getItem('adminToken')){
        var newTime = new Date();
        var Year = newTime.getFullYear()
        var Month = newTime.getMonth() + 1
        var Day = newTime.getDate() 
        var LoginTime=Year.toString()+Month.toString()+Day.toString()
        var localLoginTime=localStorage.getItem('LoginTime')
        if(LoginTime==localLoginTime){
          
        }else{
          this.$router.push({name:'AdminLogin'});
        }
      }else{
        this.$router.push({name:'AdminLogin'});
      }
    },
    watch: {
     '$route'() {
      if(localStorage.getItem('bbslistabc')){
        let bbs_id = localStorage.getItem('bbslistabc')
        var list=this.list
        for (var i = 0; i <list.length; i++) {
          if(list[i].id==bbs_id){
            this.list.splice(i,1);
            localStorage.removeItem('bbslistabc')
          }
        }
      }
      if(this.$route.params.newtime){
        if(this.$route.params.newtime != this.newtime) {
          this.list=[]
          this.params.page = 1
          this.onLoad()
        }
      }
    }
  },
  methods: {
    bbsinfo(id){
      this.$router.push({name:'Bbsinfo',params:{user_id:this.user_id,id:id}});
    },
    onLoad() {
      admin.getBbsList(this.params).then(res => {
        this.list.push.apply(this.list, res.data.data.data)
        this.params.page += 1
        this.loading = false
        this.refreshing=false
        if(res.data.data.data.length == 0) {
          this.finished = true
        }
      })
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.list=[]
      this.params.page=1
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  },
  components: {
    [List.name]:List,
    [Icon.name]:Icon,
    [PullRefresh.name]:PullRefresh,
    [NavBar.name]:NavBar
  }
}
</script>
<style lang="scss">
.bbslist{
  .bbsbox{
    margin: 15px;
    padding: 15px;
    border: 1px solid #666666;
    color: #000000;
    .bbstitle{
      font-size: 14px;
      text-align: center;
      padding-bottom: 15px;
      border-bottom: 1px solid #EEEEEE;
    }
    .bbscontent{
      display: flex;
      min-height: 50px;
      font-size: 12px;
      text-align: center;
      padding: 15px 0;
      border-bottom: 1px solid #EEEEEE;
      word-break:break-all;
      justify-content: center;
      align-items: center;
    }
    .bbsbind{
      padding-top:15px;
      font-size: 12px;
      text-align: right;
    }
  }
}
</style>
